import { useSelector } from "react-redux";
import useColors from "../customHooks/useColors";
import BaseParagraph from "../baseComponents/baseParagraph";
import { useEffect } from "react";

const TransactionDetails = ({ selectedPointsId }) => {
  const userState = useSelector((state) => state.userState);

  const [currentColors] = useColors();

  const transactions = userState.points;


  const pointsForThisTransaction =
    transactions.find((point) => {
      return point.points_id === selectedPointsId;
    }) ?? {};
  const {
    transactionId,
    transactionDetails,
    location_name,
    points_date,
    total_value,
    applied_discount,
    points: pointsFromTransaction,
  } = pointsForThisTransaction;

  return (
    <>
      <table
        style={{
          width: "100%",
          borderBottom: `1px solid ${currentColors.tertiary} `,
          margin: "15px 0px",
        }}
      >
        <thead>
          <tr style={{ borderBottom: `1px solid ${currentColors.tertiary} ` }}>
            <th style={{ width: "10%", textAlign: "center" }}>#</th>
            <th style={{ width: "22%", textAlign: "left" }}>
              <BaseParagraph>item</BaseParagraph>
            </th>
            <th style={{ width: "22%", textAlign: "center" }}>
              <BaseParagraph>quantity</BaseParagraph>
            </th>
            <th style={{ width: "22%", textAlign: "right" }}>
              <BaseParagraph>price</BaseParagraph>
            </th>
            <th style={{ width: "22%", textAlign: "right" }}>
              <BaseParagraph>total</BaseParagraph>
            </th>
          </tr>
        </thead>
        <tbody>
          {(transactionDetails ?? []).Emap((detail) => {
            const key = `${transactionId}${detail.detail_id}`;
            return (
              <tr key={key}>
                <td style={{ textAlign: "center" }}>{detail.detail_id}</td>
                <td>{detail.item_name}</td>
                <td style={{ textAlign: "center" }}>
                  {detail.quantity.toFixed(2)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {detail.unit_applied_price.toFixed(2)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {detail.total_line_item_amount.toFixed(2)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <div style={{}}>
          <BaseParagraph bold>total</BaseParagraph>
          <span style={{ marginRight: "5px" }}>:</span>
          <span>{total_value ? total_value.toFixed(2) : ""}</span>
        </div>
        <div style={{}}>
          <BaseParagraph bold>totalDiscount</BaseParagraph>
          <span style={{ marginRight: "5px" }}>:</span>
          <span>{applied_discount ? applied_discount.toFixed(2) : "0.00"}</span>
        </div>
        <div style={{}}>
          <BaseParagraph bold>pointsGenerated</BaseParagraph>
          <span style={{ marginRight: "5px" }}>:</span>
          <span>{pointsFromTransaction}</span>
        </div>
      </div>
    </>
  );
};

export default TransactionDetails;
